import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowExpandVer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowExpandVer"><Path d="M8 6.5L12 2.5L16 6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8 17.5L12 21.5L16 17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 21V3" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowExpandVer;
